export const SideBarMainMenu = (userPermissions) => {
  return [
    {
      name: 'Dashboard',
      icon: 'saf-receipt-item',
      label: 'Notifications',
      navlink: '/dashboard',
      privilege: true,
    },
  ].filter(({ privilege }) => privilege === true);
};

export const ProfileMenu = [
  {
    key: 'profile',
    icon: 'saf-frame-1',
    label: 'Profile',
    color: '',
  },
];
